<template>
  <div class="con">
    <noResultsInList :text="getNameListBook" v-if="list.length == 0" />
    <div
      id="the-book-list"
      ref="el"
      class="list-book"
      :class="{ 'h-100': $_mobile }"
      v-if="list.length > 0"
      @keydown="scrollList($event)"
      @keyup="generalShortsUp"
      tabindex="0"
      @mouseenter="setFocus"
    >
      <!-- @mouseenter="addKey"
      @mouseleave="removeKey" -->
      <!-- @keydown="scrollList($event)"
      @keypress="scrollList($event)"
      tabindex="0" -->

      <!-- <div
      class="list-book"
      v-if="list.length > 0"
      @mouseenter="addSearch"
      @mouseleave="removeSearch"
      v-shortkey="{ up: ['arrowup'], down: ['arrowdown'] }"
      @shortkey="scrollList()"
    > -->

      <RecycleScroller
        ref="listScroller"
        :buffer="180"
        style="height: 100%; direction: ltr"
        :items="list"
        :item-size="userSettings.settings.bookItemSize != 'compact' ? 37 : 25"
        v-slot="{ item, index, active }"
        class="rec-scroller"
        @mouseenter="$emit('mouseenter', $event)"
        @wheelScroll="wheelScroll"
      >
        <itemBook
          type="book"
          @open="setActiveData"
          :book="item.special ? item.book : item"
          :page="item.special ? item.page : null"
          :closeVol="
            item.special && item.allVolumes !== undefined
              ? item.allVolumes
              : true
          "
          :activeinx="activeBookIndex"
          :active="activeBook"
          :inx="index"
          @set-volumes="setVols"
          @changevol="setVolumesMode"
          @selected="selectItem"
          :select="select"
          @toggle-volumes="toggleVolumes"
          :checked="getBooksChecked[item.special ? item.book.id : item.id]"
          :showVolumes="
            getOpenVolumes[
              item.special ? item.book.mainVolume : item.mainVolume
            ]
          "
          :listIndex="index"
          @lastCheck="setLastCheck"
          @shiftCheck="doShiftCheck"
          @updateActive="updateLastActive"
          :activeInScroll="active"
        />
      </RecycleScroller>
    </div>
  </div>
</template>

<script>
import itemBook from "./itemBook.vue";
import volumes from "./volumes.vue";
import listStatus from "./listStatus.vue";
import bookwin from "@/services/book_win.js";
import onlineHelper from "@/services/onlineStations";

import { mapGetters, mapState, mapActions } from "vuex";
import { openBook as open } from "@/services/bookData.js";
import compareForCache from "@/utils/compareForCache";
import { createFreeSearchBookListStore } from "@/store_pinia";

let timeout;

let searchTxt = "";
let cacheData = null;
let cacheConfig = null;
export default {
  data() {
    return {
      maxAddToList: 20,
      maxViewList: 100,
      endList: 100,
      startList: 0,
      heightItem: 37,
      toAddHistory: true,
      listLength: 0,
      activeBook: null,
      activeBookIndex: null,
      indexActive: null,
      tempStrSearch: "",
      tempCurr: null,
      loadedInit: false,
      newList: 0,
      select: null,
      scrollToTop: 0,
      lastCheck: 0,
      lastBookClicked: 0,
      indexUpdateTimer: null,
      lastListIndex: -1,
    };
  },
  components: {
    itemBook,
    listStatus,
    volumes,
  },
  computed: {
    ...mapGetters("bookList", [
      "getCurrentList",
      "getCurrentListType",
      "getNameListBook",
      "getDataOfCurrentList",
      "getBooksChecked",
      "getTextSearchInput",
      "getOpenVolumes",
      "showVols",
      "getLengthOfCurrentList",
      "getDoNotFocus",
    ]),
    ...mapState("bookList", [
      "refreshListTrigger",
      "initBook",
      "showHiddenBooks",
      "refreshOpenVols",
      "triggerScrollToTop",
    ]),
    ...mapState("booklistComp", ["firstActive"]),
    ...mapGetters("booklistComp", ["getSortBy"]),
    ...mapGetters("tabsManager", [
      "getCurrentBook",
      "getCurrentTabData",
      "showBookLists",
      "isCurrentTabPinned",
    ]),
    openSdarot() {
      if (
        this.tempStrSearch == this.getTextSearchInput &&
        this.tempCurr == this.getCurrentListType
      )
        return true;
      else {
        return false;
      }
    },
    isMaagarim() {
      return (
        (this.getDataOfCurrentList.data.type == "SYSTEM_LIST" &&
          this.getDataOfCurrentList.data.categoryTypeId === 4) ||
        this.getDataOfCurrentList.data.type == "SAVED_LIST"
      );
    },
    hideVols() {
      return !this.showVols &&
        (this.getSortBy == "book" ||
          this.getSortBy == "author" ||
          this.getSortBy == "dorot" ||
          (this.getSortBy == "year" &&
            (this.getCurrentListType == "SEARCH" ||
              this.getTextSearchInput != ""))) &&
        (this.getCurrentListType == "ALL" ||
          this.getCurrentListType == "SEARCH" ||
          this.getCurrentListType == "AUTHOR_LIST" ||
          //close series in ספרי יסוד
          (this.getDataOfCurrentList.data.type == "CUSTOM_LIST" &&
            this.getDataOfCurrentList.data.content == "ספרי יסוד") ||
          //close series in מאגרים
          this.isMaagarim ||
          this.getTextSearchInput !== "")
        ? true
        : false;
    },
    list() {
      let _vm = this;
      let list = this.getCurrentList;

      let react = this.$store.state.booksChanged;
      let ltype;
      const refVols = this.refreshOpenVols;
      this.tempCurr = ltype = this.getCurrentListType;
      const showHide = this.showHiddenBooks;
      const enableHide = this.userSettings.settings.enableHidden != "0";

      //should add the hidden react data s too TODO
      let newCacheConfig = {
        enableHide,
        list,
        showHide,
        react,
        ltype,
        refVols,
        hideVol: this.hideVols,
      };

      if (compareForCache(newCacheConfig, cacheConfig, cacheData)) {
        return cacheData;
      }
      // list = list.filter((b) => b._show && !b._hide);
      // if (!showHide && enableHide) {

      list = list.filter((book) => {
        let b = book.special ? book.book : book;

        if (!b._show) return false;
        if (!showHide && enableHide) {
          if (ltype == "HIDDEN_LIST") {
            if (b._inHide) return true;
            return false;
          }
          if (b._hide) return false;
          return true;
        } else return true;
      });
      //  }

      this.tempStrSearch = this.getTextSearchInput;

      if (this.hideVols) {
        const isgetCurrentListTypeEqSearch =
          _vm.getCurrentListType === "SEARCH";
        const isgetTextSearchInputEmpty = _vm.getTextSearchInput.trim() === "";
        list = list.filter((book) => {
          let x = book.special ? book.book : book;
          let allVolumes =
            book.special && book.allVolumes !== undefined
              ? book.allVolumes
              : true;
          if (
            (!isgetCurrentListTypeEqSearch &&
              !this.isMaagarim &&
              isgetTextSearchInputEmpty) ||
            (!isgetCurrentListTypeEqSearch &&
              !isgetTextSearchInputEmpty &&
              allVolumes === true) ||
            (isgetCurrentListTypeEqSearch && allVolumes === true) ||
            (this.isMaagarim && allVolumes === true)
          ) {
            if (x.mainVolume != null && !x.changed) {
              if (this.getOpenVolumes[x.mainVolume] != undefined) {
                return true;
              } else if (x.id == x.mainVolume) {
                return true;
              }
              return false;
            }
          }
          return true;
        });
      }

      cacheData = list;
      cacheConfig = newCacheConfig;
      this.listLength = list.length;

      //this.refreshList = !this.refreshList;

      return list;
    },
    endListComputed() {
      if (this.lenghList == this.maxViewList) return this.maxViewList;
      else return this.endList;
    },

    lenghList() {
      return this.listLength;
    },
    heightAllList() {
      if (this.$store.state.bookList.currentListLength == 0) return "0";
      return this.$store.state.bookList.currentListLength * this.heightItem;
    },
    calcHeightRectTop() {
      // if (this.$store.state.bookList.currentListLength == 0) return "0";
      if (this.startList > 0) return this.startList * this.heightItem + "px";
      return "0";
    },
    calcHeightRectBottom() {
      if (this.$store.state.bookList.currentListLength == 0) return "0";
      let x = this.endList * this.heightItem;
      let heightRec = this.heightAllList - x;
      return heightRec + "px";
      return "100px";
    },
  },
  watch: {
    triggerScrollToTop: function (val, oVal) {
      this.scrollToTop++;
    },
    refreshListTrigger: function (val, oVal) {
      this.$store.state.booksChanged++;
    },
    initBook: function (val, oVal) {
      let bookFound = 0;
      if (val > 0) {
        this.$store.state.lastActiveList = 1;
        let found = this.list.findIndex(
          (l) => (l.special ? l.book.id : l.id) == this.initBook
        );

        if (found > 0) {
          this.startList = found;
          this.$store.state.currentActiveListIndex = found.toString();
        } else {
          for (let j = 0; j < this.list.length && bookFound == 0; j++) {
            let element = this.list[j];

            if (element.volumes_length)
              for (
                let i = 0;
                i < element.volumes_length && bookFound == 0;
                i++
              ) {
                if (element[`volumes_${i}_id`] == this.initBook)
                  bookFound = element.mainVolume;
              }
          }
          if (bookFound > 0) {
            this.setVolumes({ book: bookFound, value: true }).then(() => {
              this.$nextTick(() => {
                found = this.list.findIndex((l) => l.id == this.initBook);

                if (found > 0) {
                  this.startList = found;
                  this.$store.state.currentActiveListIndex = found.toString();
                }
              });
            });
          }
        }

        if (found > 0) this.$refs.listScroller.scrollToItem(found);
      }
    },
    getCurrentList: function (newv, old) {
      if (old == newv) return;
      if (!this.showBookLists) this.toggleShowBookLists(false);
      if (
        this.getDataOfCurrentList.data.type == "SEARCH" &&
        this.$store.state.bookList.dontScroll
      ) {
        this.$store.state.bookList.dontScroll = false;
        return;
      }

      if (this.getDataOfCurrentList.data.current == 0) {
        this.$store.state.currentActiveListIndex = "0";
        this.$store.state.lastActiveList = 1;
        this.newList++;
        this.setFirstActive(true);
      } else {
        let lastActive = this.getDataOfCurrentList.data.lastActive;
        if (!lastActive || lastActive == -1) lastActive = 0;

        // fix incorrect scrolling after book search (avichai bug)
        if (
          this.getDataOfCurrentList.data.type == "SEARCH" &&
          this.getDataOfCurrentList.data.content !=
            this.$store.state.bookList.textSearch
        )
          lastActive = 0;

        this.startList = parseInt(lastActive);
        this.$nextTick(() => {
          if (this.$refs.listScroller)
            this.$refs.listScroller.scrollToItem(lastActive);
        });

        this.$store.state.currentActiveListIndex = lastActive.toString();
        this.$store.state.lastActiveList = 1;
        if (this.startList == 0) this.newList++;
        this.$nextTick(() => {
          this.clickBook(false, true);
        });
      }
    },
    /*  getCurrentList: {
      immediate: true,
      handler: function(newv, old) {
        if (!this.showBookLists) this.toggleShowBookLists();
        if (old == newv) return;

        if (
          this.getDataOfCurrentList.data.type == "SEARCH" &&
          this.$store.state.bookList.dontScroll
        ) {
          this.$store.state.bookList.dontScroll = false;
          return;
        }

        if (this.getDataOfCurrentList.data.current == 0) {
          this.$store.state.currentActiveListIndex = "0";
          this.$store.state.lastActiveList = 1;
          this.newList++;
          this.setFirstActive(true);
        } else {
          let lastActive = this.getDataOfCurrentList.data.lastActive;
          if (!lastActive || lastActive == -1) lastActive = 0;
          this.startList = lastActive;
          this.$store.state.currentActiveListIndex = lastActive.toString();
          this.$store.state.lastActiveList = 1;
          //this.newList++;
          this.clickBook(false, true);
        }
      },
    }, */
    getNameListBook: function () {
      if (this.getNameListBook == "" || this.getNameListBook === undefined)
        return (this.toAddHistory = true);
    },
    getCurrentBook: function () {
      if (this.$store.state.lastActiveList == 2) return;
      let book = this.getCurrentBook;
      let bkdata = this.getCurrentTabData;
      if (book == -1) return;
      this.activeBook = book;
      let el = this.$refs.el;
      if (!el) return;
      el = el.querySelector(".rec-scroller");
      let lst = el.querySelectorAll(".item-book");
      lst = [...lst];
      // const bkDom = lst.find((a) => a.className.includes("active"));
      // this.indexActive = inx;

      this.indexActive = this.list.findIndex(
        (item) => item.id == this.activeBook
      );
    },
    firstActive: function (val) {
      if (!val) return;

      this.setFirstActive(false);
      if (this.list.length == 0) return;
      if (this.$refs.listScroller) this.$refs.listScroller.scrollToItem(0);

      this.activeBook = this.list[0].id;
      this.indexActive = 0;
      this.$store.state.currentActiveListIndex = "0";
      this.$store.state.lastActiveList = 1;
      let el = this.$refs.el;
      if (!el) return;
      //if (val !== true)
      //if (this.$refs.el)
      //we come from down key on search input
      if (!this.getDoNotFocus) el.focus();
      else this.setDoNotFocus(false);
      // el = el.querySelector(".list-book-inner");

      this.clickBook(false);
      // el.scrollTop = 0;
      this.scrollList({ code: "DOWN", getModifierState: () => false });
    },
  },
  methods: {
    ...mapActions("booklistComp", ["setFirstActive"]),
    ...mapActions("bookList", [
      "setSearchTo",
      "toggleOpenVols",
      "setOpenVols",
      "setVolumes",
      "setDoNotFocus",
      "checkBook",
      "toggleCheck",
      "updateCurrentListLastIndex",
    ]),
    ...mapActions("tabsManager", ["toggleShowBookLists"]),
    updateLastActive(inx) {
      if (this.getDataOfCurrentList.current != 1) {
        if (
          this.lastListIndex == -1 ||
          this.lastListIndex == this.getDataOfCurrentList.current
        )
          clearTimeout(this.indexUpdateTimer);
        this.indexUpdateTimer = setTimeout(() => {
          this.updateCurrentListLastIndex({
            listId: this.getDataOfCurrentList.current,
            index: inx,
          });
        }, 1000);
      }

      this.lastListIndex = this.getDataOfCurrentList.current;
    },
    setFocus() {
      return; // temporary because of screen jumping
      this.$refs.el.focus();
    },
    setLastCheck(index) {
      this.lastCheck = index;
    },
    doShiftCheck(index) {
      let start = this.lastCheck;
      let end = index;
      if (start > end) {
        end = start;
        start = index;
      }

      for (let i = start; i <= end; i++) {
        let book = this.list[i];
        this.checkBook({ book: book.id, check: true });
        if (book.volumes_length > 0) {
          let mainVol = book.mainVolume;
          const vol_len = book.volumes_length;
          let list = [];
          for (let i = 0; i < vol_len; i++) {
            const bid = book[`volumes_${i}_id`];
            if (bid != mainVol) list.push(bid);
          }
          list.forEach((l) => {
            this.checkBook({ book: l, check: true });
          });
        }
      }
      this.lastCheck = 0;
    },
    setVols(book, value, volumesCount) {
      this.setVolumes({ book, value }).then(() => {
        // this.$store.state.booksChanged++;
      });
      if (!value) volumesCount *= -1;

      // this.listLength += volumesCount;
    },
    toggleVolumes(bookId, volumesCount) {
      if (this.getOpenVolumes[bookId]) volumesCount *= -1;
      this.toggleOpenVols(bookId).then(() => {
        //this.$store.state.booksChanged++;
      });
    },
    setVolumesMode(payload) {
      this.setOpenVols(payload);
    },
    doSearch(event) {
      // if (event.key > "[" && event.key < "~") searchTxt += event.key;
      // else
      // let keys =
      //   "אבגדהוזחטיכלמנסעפצקרשתןםץךף- abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPWRSTUVWXYZ";
      // if (keys.includes(event.key)) searchTxt += event.key;
      // else if (event.key == "Backspace")
      //   searchTxt = searchTxt.substring(0, searchTxt.length - 1);
      // clearTimeout(timeout);
      // timeout = setTimeout(() => {
      //   this.setSearchTo(searchTxt);
      // }, 250);
      // alert(event.target);
    },

    addHistory() {
      if (this.getNameListBook != "") {
        let payload = {
          type: "SEARCH",
          content: "",
        };
        this.$store.dispatch("bookList/addUserActionToHistory", payload);
      }
    },

    scrollPage() {
      if (this.$refs.listScroller)
        this.$refs.listScroller.scrollToItem(
          parseInt(this.$store.state.currentActiveListIndex)
        );
      /*  let el = this.$refs.el;
      let list = el.querySelector(".list-book-inner");
      list.scrollTop =
        parseInt(this.$store.state.currentActiveListIndex) * this.heightItem; */
    },
    openBookInNewWindow(book) {
      bookwin.createWinBook(book, 1);
    },
    async generalShortsUp(event) {
      let numlock = event.getModifierState("NumLock");

      switch (event.code) {
        case "ShiftLeft":
        case "ShiftRight":
          this.$store.state.shiftPress = false;

          break;
        case "ArrowUp":
        case "PageUp":
        case "Numpad8":
        case "Numpad9":
          if ((event.code == "Numpad8" || event.code == "Numpad9") && numlock)
            break;
          // this.move(-1);
          // this.scrollToElementIfNeeded("up");
          // clearTimeout(timeout);

          clearInterval(globalThis.scrollInterval);
          clearInterval(globalThis.clickBookInterval);
          globalThis.scrollInterval = null;
          globalThis.clickBookInterval = null;
          //this.move(-1);
          //this.scrollToElementIfNeeded("up");
          if (this.geCurrBookId() !== this.lastBookClicked)
            this.clickBook(false, true);

          break;
        case "ArrowDown":
        case "PageDown":
        case "Numpad3":
        case "Numpad2":
          if ((event.code == "Numpad2" || event.code == "Numpad3") && numlock)
            break;
          // this.move(1);
          // this.scrollToElementIfNeeded();
          //clearTimeout(timeout);
          clearInterval(globalThis.scrollInterval);
          clearInterval(globalThis.clickBookInterval);

          globalThis.scrollInterval = null;
          globalThis.clickBookInterval = null;
          // this.move(1);
          // this.scrollToElementIfNeeded();
          if (this.geCurrBookId() !== this.lastBookClicked)
            this.clickBook(false, true);

          break;
      }
    },
    scrollList(event) {
      this.toggleVolumeByKey(event);

      this.pinTab(event);

      this.newTab(event);

      let trigger = true;
      let numlock = event.getModifierState("NumLock");
      let _vm = this;
      let bookItemList =
        this.list[parseInt(this.$store.state.currentActiveListIndex)];

      let bookItem = bookItemList.special ? bookItemList.book : bookItemList;

      let bookId = bookItem.id;

      switch (event.code) {
        case "Enter":
        case "NumpadEnter":
          event.stopPropagation();
          event.preventDefault();

          this.openBookInNewWindow(bookId);
          break;
        case "Space":
          try {
            event.stopPropagation();
            event.preventDefault();
            // if is mainvolume and closed check all vols
            let books = [bookId];

            const isClosed =
              bookItemList.special && bookItemList.allVolumes !== undefined
                ? bookItemList.allVolumes
                : true;
            try {
              if (
                !this.showVols &&
                bookItem.mainVolume &&
                !this.getOpenVolumes[bookItem.mainVolume] &&
                isClosed
              ) {
                const vol_len = bookItem.volumes_length;
                // let listIds = this.book.volumes;
                let volumes = [];
                for (let i = 0; i < vol_len; i++) {
                  const bid = bookItem[`volumes_${i}_id`];
                  if (bid != bookItem.mainVolume) volumes.push(bid);
                }
                books = books.concat(volumes);
              }
            } catch (ex) {
              console.log(ex);
            }

            books.forEach((book) => {
              this.toggleCheck({ book });
            });

            this.move(1);

            this.scrollToElementIfNeeded();
          } catch (ex) {
            console.log(ex);
          }
          break;
        case "ShiftLeft":
        case "ShiftRight":
          event.stopPropagation();
          event.preventDefault();

          this.$store.state.shiftPress = true;
          trigger = false;
          break;

        case "F2":
          event.preventDefault();
          event.stopPropagation();
          this.$store.state.bookList.setFocusInInput++;
          break;
        case "F3":
          event.preventDefault();
          event.stopPropagation();
          createFreeSearchBookListStore("main").focusInInput++;
          break;
        case "Tab":
          if (!event.shiftKey && !event.ctrlKey) {
            event.preventDefault();
            event.stopPropagation();
            let bookElement = document.getElementById(
              `the-book${this.$store.state.tabsManager.currentTabId}`
            );
            document.getElementById("the-book-list").blur();
            if (bookElement) bookElement.focus();
          }
          break;
        case "PageDown":
        case "Numpad3":
          event.preventDefault();
          event.stopPropagation();
          if (event.code == "Numpad3" && numlock) break;
          if (!globalThis.scrollInterval) {
            this.move(1, true);
            this.scrollPage();
            this.clickBook(false, true);

            //start interval
            globalThis.scrollInterval = setInterval(() => {
              this.move(1, true);
              this.scrollPage();
            }, 100);

            if (!globalThis.clickBookInterval)
              globalThis.clickBookInterval = setInterval(() => {
                _vm.clickBook(false, true);
              }, 700);
          }
          trigger = false;

          /*  this.move(1, true);
          this.scrollPage(); */
          break;
        case "PageUp":
        case "Numpad9":
          event.preventDefault();
          event.stopPropagation();
          if (event.code == "Numpad9" && numlock) break;

          if (!globalThis.scrollInterval) {
            this.move(-1, true);
            this.scrollPage();
            this.clickBook(false, true);

            //start interval
            globalThis.scrollInterval = setInterval(() => {
              this.move(-1, true);
              this.scrollPage();
            }, 100);

            if (!globalThis.clickBookInterval)
              globalThis.clickBookInterval = setInterval(() => {
                _vm.clickBook(false, true);
              }, 700);
          }
          trigger = false;

          /*  this.move(-1, true);
          this.scrollPage(); */
          break;
        /*  case "Numpad8":
          if (event.code == "Numpad8" && numlock) break;
          this.move(-1);
          this.scrollToElementIfNeeded("up");
          break;
        case "Numpad2":
          if (event.code == "Numpad2" && numlock) break;
          this.move(1);
          this.scrollToElementIfNeeded();
          break; */
        case "ArrowUp":
        case "Numpad8":
          event.preventDefault();
          event.stopPropagation();
          if (event.code == "Numpad8" && numlock) break;
          // clearTimeout(timeout);
          if (!globalThis.scrollInterval) {
            this.move(-1);
            this.scrollToElementIfNeeded("up");
            this.clickBook(false, true);

            //start interval
            globalThis.scrollInterval = setInterval(() => {
              _vm.move(-1);
              _vm.scrollToElementIfNeeded("up");
            }, 200);

            if (!globalThis.clickBookInterval)
              globalThis.clickBookInterval = setInterval(() => {
                _vm.clickBook(false, true);
              }, 1000);
          }
          trigger = false;
          break;
        case "ArrowDown":
        case "Numpad2":
          event.preventDefault();
          event.stopPropagation();
          if (event.code == "Numpad2" && numlock) break;
          // clearTimeout(timeout);
          if (!globalThis.scrollInterval) {
            this.move(1);
            this.scrollToElementIfNeeded();
            this.clickBook(false, true);

            //start interval
            globalThis.scrollInterval = setInterval(() => {
              _vm.move(1);
              _vm.scrollToElementIfNeeded();
            }, 200);

            if (!globalThis.clickBookInterval)
              globalThis.clickBookInterval = setInterval(() => {
                _vm.clickBook(false, true);
              }, 1000);
          }
          trigger = false;
          break;
        default:
          trigger = false;
      }

      if (trigger) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          this.clickBook(false);
        }, 100);
      }
    },
    wheelScroll(event) {
      if (this.$store.state.lastActiveList == 2) {
        this.$store.state.lastActiveList = 1;
        this.setActive();
        this.$store.state.currentActiveListIndex = this.indexActive;
      }

      onlineHelper.startOnlineTimer(true);
      if (
        !this.userSettings.settings.mouse_wheel ||
        this.userSettings.settings.mouse_wheel === "scroll"
      )
        return;

      event.stopPropagation();
      event.preventDefault();

      let delta = event.wheelDeltaY / event.wheelDelta;
      let dir = "down";
      if (event.wheelDelta > 0) dir = "up";
      let num = (dir === "down" ? 1 : -1) * delta;
      this.move(num);
      this.scrollToElementIfNeeded(dir);
      // this.elementInViewport(dir);
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        this.clickBook(false, true);
      }, 20);
    },
    async clickBook(addToHistory = true, forceSameTab = false) {
      let item = this.list[parseInt(this.$store.state.currentActiveListIndex)];
      this.updateLastActive(this.$store.state.currentActiveListIndex);
      if (item == undefined) return;
      let book;
      if (item.special) book = item.book;
      else book = item;
      let bookId = this.geCurrBookId();
      if (bookId == -1) return;
      this.lastBookClicked = this.bookId;
      let page = -1;
      if (book.page) page = book.page;
      if (item.page) page = "P" + item.page;
      let extraData = {};
      //if (book.fs != undefined) extraData.fs = book.fs;
      if (addToHistory) {
        this.addHistory();
      }

      //third param is if book should open in new tab. depends on user settings
      open(bookId, page, null, extraData.fs, forceSameTab);
      // let el = this.$refs.el;
      // el = el.querySelector(".list-book-inner");
      // el.querySelector(".item-book.active").focus();
    },
    geCurrBookId() {
      let item = this.list[parseInt(this.$store.state.currentActiveListIndex)];

      if (item == undefined) return -1;
      let book;
      if (item.special) book = item.book;
      else book = item;
      return book.id;
    },
    scrollToElementIfNeeded(dir = "down") {
      if (this.$refs.listScroller) {
        const bookElem = this.$el.querySelectorAll(
          '.item-book[inx="' +
            this.$store.state.currentActiveListIndex +
            '"][activeInScroll=true]'
        );

        if (bookElem.length > 0)
          bookElem[0].scrollIntoViewIfNeeded({ behavior: "smooth" });
        else
          this.$refs.listScroller.scrollToItem(
            parseInt(this.$store.state.currentActiveListIndex)
          );
      }

      return;
      let calcScroll;
      let list = this.$refs.el;
      if (!list) return;
      list = list.querySelector(".list-book-inner");
      if (!list) return;
      let top = list.offsetTop;

      if (dir === "down") {
        let elem = list.querySelector(
          `.item-book#book_${
            parseInt(this.$store.state.currentActiveListIndex) - 1
          }`
        );
        if (!elem) {
          list.scrollTop =
            parseInt(this.$store.state.currentActiveListIndex) *
            this.heightItem;

          return;
        }

        let height = list.offsetHeight;
        let offset = top + height;
        let topElem = elem.offsetTop - list.scrollTop + elem.offsetHeight; // * 2;
        calcScroll = offset - (elem.offsetTop - list.scrollTop);
        if (offset <= topElem) {
          list.scrollTop =
            list.scrollTop + elem.offsetHeight + elem.offsetHeight - calcScroll;
        }
      } else {
        let elem = list.querySelector(
          `.item-book#book_${
            parseInt(this.$store.state.currentActiveListIndex) + 1
          }`
        );
        if (!elem) {
          list.scrollTop =
            parseInt(this.$store.state.currentActiveListIndex) *
            this.heightItem;

          return;
        }
        calcScroll = elem.offsetTop - list.scrollTop - top;
        if (top > elem.offsetTop - list.scrollTop - elem.offsetHeight) {
          list.scrollTop =
            parseInt(this.$store.state.currentActiveListIndex) *
            this.heightItem;
        }
      }
    },
    tabIdForOpenBook() {
      let tab = null;
      if (
        (this.userSettings.settings.newTabMode &&
          this.userSettings.settings.newTabMode == "1") ||
        this.isCurrentTabPinned
      ) {
        tab = new Date().getTime();
      }
      return tab;
    },
    pinTab(event) {
      if (event.ctrlKey && "bBנ".indexOf(event.key) !== -1) {
        if (this.$store.state.tabsManager.currentTabId)
          this.$store.dispatch(`tabsManager/togglePinTab`, {
            tabId: this.$store.state.tabsManager.currentTabId,
          });

        event.preventDefault();
      }
    },
    newTab(event) {
      if (event.ctrlKey && "מnN".indexOf(event.key) !== -1) {
        this.$store.state.bookList.fromKeyboard = true;
        let newTab = new Date().getTime();
        open(-1, -1, newTab);

        event.preventDefault();
      }
    },
    toggleVolumeByKey(e) {
      let book = this.list[parseInt(this.$store.state.currentActiveListIndex)]; // this.getCurrentBook;
      if (!book) return;
      if (book.special) book = book.book;
      if (book.mainVolume == undefined) return;

      book = book.mainVolume;

      if (e.key == "+") {
        this.setVolumesMode({ book, mode: "open" });
      } else if (e.key == "-") {
        this.setVolumesMode({ book, mode: "close" });
      }
    },
    move(num, page = false) {
      let multiple = 1;
      if (page) {
        let numBooksInView = Math.floor(
          this.$refs.el.clientHeight / this.heightItem
        );
        multiple = numBooksInView - 1;
      }
      let gotoIndex =
        parseInt(this.$store.state.currentActiveListIndex) + num * multiple;
      if (gotoIndex < 0) gotoIndex = 0;
      else if (gotoIndex > this.list.length - 1)
        gotoIndex = this.list.length - 1;
      this.$store.state.currentActiveListIndex = gotoIndex.toString();
    },
    setActive(dir, page = false) {
      let item;
      let multiple = 1;
      let goto;
      if (page) {
        let numBooksInView = Math.floor(
          this.$refs.el.clientHeight / this.heightItem
        );
        multiple = numBooksInView - 1;
      }
      if (dir == "up") {
        if (this.indexActive == 0) return;
        goto = this.indexActive + multiple * -1;
        if (goto < 0) goto = 0;
      } else {
        if (this.indexActive == this.list.length) return;
        goto = this.indexActive + multiple * 1;
        if (goto > this.list.length) goto = this.list.length;
      }
      this.indexActive = goto;
      item = this.list[this.indexActive];
      const pageinx = item.special ? item.page : null;
      this.activeBookIndex = pageinx;
      this.activeBook = item.id;
    },

    setActiveData(data) {
      this.activeBook = data.bookId;
      this.activeBookIndex = data.inx;
      this.indexActive = data.inx;
    },
    selectItem(id) {
      this.select = id;
    },
  },
  beforeDestroy() {
    let scrollEl = document
      ?.querySelector("#the-book-list")
      ?.querySelector(".vue-recycle-scroller__item-wrapper");
    if (scrollEl) scrollEl.removeEventListener("wheel", this.wheelScroll);
  },
  mounted() {
    // this.getCurrentListToMem();
    this.activeBook = this.getCurrentBook;
    let scrollEl = document
      ?.querySelector("#the-book-list")
      ?.querySelector(".vue-recycle-scroller__item-wrapper");
    if (scrollEl) scrollEl.addEventListener("wheel", this.wheelScroll);
    else {
      console.log("cannot add scrollEl wheel event");
    }
  },
};
</script>

<style lang="scss" scoped>
.con {
  height: calc(100% - 179px);
  flex-grow: 1;
}

.itemTest {
  height: 10%;
  height: 100px;
  border: 1px solid;
  font-size: 25px;
  font-weight: bold;
  text-align: center;
  line-height: 100px;
}

.list-book {
  outline: 0;
  height: calc(100% - 26px);
  height: 100%;
  // border-top: 2px solid rgba(0, 0, 0, 0.1);
  direction: ltr;
}
.test {
  background: red;
  // height: 300px;
}
</style>
